
<template>
    <div class="details"> 
        <div class="details_content">
            <div class="title">{{info.shareTitle}}</div>
            <div class="tip">
            <span v-if="info.visit">浏览 {{info.visit}}</span><span>{{info.createTime}}</span>
            </div>
            <div class="info" v-html="info.content"></div>
        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
export default {
   data(){
    return{
         info:{}
    }
   },
   created(){
     this.getDetails()
   },
   methods:{
      getDetails(){
         this.http.get(`/api/front/article/info?id=${this.$route.query.id}`).then((res)=>{
                this.info = res.data.data     
            
            })
      },
      beforeRouteLeave (to, from, next) {
        to.meta.keepAlive = true // 给列表(list.vue)页面设置keepAlive
        next()
    },
   }

}
</script>

<style lang="less">
.details{
    background: #F5F5F5;
    height: calc(100% -0.5rem);
    padding-bottom: 0.8rem;
    .details_content{
        margin: 0.24rem 0.2rem;
        background: #fff;
        padding: 0.75rem 0.26rem;
        padding-bottom: 0.2rem;
        font-size: 0.28rem;
        color: #000;
        .title{
            font-size: 0.28rem;
            color: #000;
            font-weight: bold;
            
            
        }
        .tip{
            span{
                display: inline-block;
                background: #F5F5F5;
                border-radius: 0.04rem;
                color: #666666;
                font-size: 0.2rem;
                margin-right: 0.18rem;
                padding: 0.05rem 0.1rem;
                
            }
            padding: 0.2rem 0.05rem;
            border-bottom: 1px solid #EDEDED;
          }
          .info{
              margin-top: 0.26rem;
              section{
                img{
                    max-width: 100%!important;
                    height: auto!important;
                }
                p{
                    line-height: 0.5rem;
                    span{
                        line-height: 0.5rem;
                    }
                }
              }
              p{
                img{
                    max-width: 100%!important;
                    height: auto!important;  
                }
              }
              img{
                    max-width: 100%!important;
                    height: auto!important;
                }
          }
    }                                       
}
</style>


// WEBPACK FOOTER //
// src/modules/detail.vue